const num = (value) => (value == null ? 0 : Number(value));

/** Millions collapse to "$12.40M"; anything smaller keeps full digits ("$900,000"). */
export function formatAum(value) {
  const amount = num(value);
  if (Math.abs(amount) >= 1_000_000) {
    return `$${(amount / 1_000_000).toFixed(2)}M`;
  }
  return formatCurrency(amount);
}

export function formatCurrency(value) {
  return `$${Math.round(num(value)).toLocaleString('en-US')}`;
}

export function formatNumber(value) {
  return num(value).toLocaleString('en-US');
}

/**
 * Surnames reduce to initials: "John Doe" -> "John D.". Apostrophe-joined names
 * keep both initials, so "Sean O'Connor" -> "Sean O'C.". Mononyms pass through.
 */
export function abbreviateName(name) {
  const parts = String(name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return parts[0] ?? '';

  const surname = parts[parts.length - 1]
    .split("'")
    .map((segment) => segment.charAt(0).toUpperCase())
    .filter(Boolean)
    .join("'");

  return `${parts[0]} ${surname}.`;
}

/** Always signed, one decimal: "+38.6%". Null when the API has no ratio to report. */
export function formatPercent(value, decimals = 1) {
  if (value == null) return '—';
  const sign = value > 0 ? '+' : '';
  return `${sign}${Number(value).toFixed(decimals)}%`;
}
